<div class="cdrs-container">
    <div class="title">
        <fa-icon [icon]="faAngleRight"></fa-icon>
        <span>{{ 'Cdrs.Title' | translate }}</span>
    </div>

    <div class="table-container">
        <form class="filters-form" [formGroup]="filtersForm">
            <div class="mat-elevation-z8">
                <table mat-table [dataSource]="dataSource" matSort>
                    <ng-container matColumnDef="setupTime">
                        <th mat-header-cell *matHeaderCellDef class="small">
                            <span mat-sort-header>{{ 'Cdrs.SetupTime' | translate }}</span>
                            <mat-form-field class="form-field" appearance="outline">
                                <mat-date-range-input [rangePicker]="setupTime">
                                    <input matStartDate placeholder="{{ 'Cdrs.StartDate' | translate }}" (dateChange)="fromDate('change', $event)" />
                                    <input matEndDate placeholder="{{ 'Cdrs.EndDate' | translate }}" (dateChange)="toDate('change', $event)" />
                                </mat-date-range-input>
                                <mat-datepicker-toggle matIconSuffix [for]="setupTime"></mat-datepicker-toggle>
                                <mat-date-range-picker #setupTime></mat-date-range-picker>
                            </mat-form-field>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.setupTime | date : 'dd/MM/yyyy' }}
                            <br />
                            {{ element.setupTime | date : 'HH:mm:ss' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="flow">
                        <th mat-header-cell *matHeaderCellDef class="small">
                            <span mat-sort-header>{{ 'Cdrs.Flow' | translate }}</span>
                            <mat-form-field class="form-field" appearance="outline">
                                <input matInput (keyup)="applyFilters('flow', $event.target)" autocomplete="off" />
                                <button
                                    mat-icon-button
                                    matSuffix
                                    class="mat-accent search-icon"
                                    matTooltip="{{ 'Cdrs.ResetFilterColumn' | translate }}"
                                    (click)="resetColumnFilter('flow')">
                                    <mat-icon>undo</mat-icon>
                                </button>
                            </mat-form-field>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <table>
                                <tr>
                                    <td>{{ element.from }}</td>
                                    <td><mat-icon matListItemIcon>east</mat-icon></td>
                                    <td>
                                        <sup>({{ element.ringDuration }}s)</sup>
                                    </td>
                                    <td><mat-icon matListItemIcon>east</mat-icon></td>
                                    <td>{{ element.to }}</td>
                                    <td>
                                        <sup>({{ element.talkDuration }}s)</sup>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="caller">
                        <th mat-header-cell *matHeaderCellDef class="small">
                            <span mat-sort-header>{{ 'Cdrs.Caller' | translate }}</span>
                            <div class="small">
                                <mat-form-field class="form-field" appearance="outline">
                                    <input matInput (keyup)="applyFilters('caller', $event.target)" autocomplete="off" />
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'Cdrs.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('caller')">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <table>
                                <tr>
                                    <td rowspan="2">
                                        @if (element.callerType=='user') {
                                        <mat-icon matListItemIcon>person</mat-icon>
                                        } @if (element.callerType=='group') {
                                        <mat-icon matListItemIcon>group</mat-icon>
                                        } @if (element.callerType=='queue') {
                                        <mat-icon matListItemIcon>queue_music</mat-icon>
                                        } @if (element.callerType=='service') {
                                        <mat-icon matListItemIcon>settings_suggest</mat-icon>
                                        } @if (element.callerType=='function') {
                                        <mat-icon matListItemIcon>memory</mat-icon>
                                        } @if (element.callerType=='external') {
                                        <mat-icon matListItemIcon>call</mat-icon>
                                        } @if (element.callerType=='device') {
                                        <mat-icon matListItemIcon>fax</mat-icon>
                                        } @if (!element.callerType || element.callerType=='none') {
                                        <mat-icon matListItemIcon>call</mat-icon>
                                        }
                                    </td>
                                    <td>
                                        {{ element.callerName }}
                                        @if (element.callerName!=element.callerAddress) {
                                        <sup>&nbsp;({{ element.callerAddress }})</sup>
                                        }
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="called">
                        <th mat-header-cell *matHeaderCellDef class="small">
                            <span mat-sort-header>{{ 'Cdrs.Called' | translate }}</span>
                            <div class="small">
                                <mat-form-field class="form-field" appearance="outline">
                                    <input matInput (keyup)="applyFilters('called', $event.target)" autocomplete="off" />
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'Cdrs.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('called')">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <table>
                                <tr>
                                    <td rowspan="3">
                                        @if (element.calledType=='user') {
                                        <mat-icon matListItemIcon>person</mat-icon>
                                        } @if (element.calledType=='group') {
                                        <mat-icon matListItemIcon>group</mat-icon>
                                        } @if (element.calledType=='queue') {
                                        <mat-icon matListItemIcon>queue_music</mat-icon>
                                        } @if (element.calledType=='service') {
                                        <mat-icon matListItemIcon>settings_suggest</mat-icon>
                                        } @if (element.calledType=='function') {
                                        <mat-icon matListItemIcon>memory</mat-icon>
                                        } @if (element.calledType=='external') {
                                        <mat-icon matListItemIcon>call</mat-icon>
                                        } @if (element.calledType=='device') {
                                        <mat-icon matListItemIcon>fax</mat-icon>
                                        } @if (!element.calledType || element.calledType=='none') {
                                        <mat-icon matListItemIcon>call</mat-icon>
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        {{ element.calledName }}
                                        @if (element.calledName!=element.calledAddress) {
                                        <sup>&nbsp;({{ element.calledAddress }})</sup>
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <sup>{{ 'CdrStates.' + element.calledState | translate }}</sup>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="talker">
                        <th mat-header-cell *matHeaderCellDef class="small">
                            <span mat-sort-header>{{ 'Cdrs.Talker' | translate }}</span>
                            <div class="small">
                                <mat-form-field class="form-field" appearance="outline">
                                    <input matInput (keyup)="applyFilters('talker', $event.target)" autocomplete="off" />
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'Cdrs.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('talker')">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <table>
                                <tr>
                                    <td rowspan="3">
                                        @if (element.talkerType=='user') {
                                        <mat-icon matListItemIcon>person</mat-icon>
                                        } @if (element.talkerType=='group') {
                                        <mat-icon matListItemIcon>group</mat-icon>
                                        } @if (element.talkerType=='queue') {
                                        <mat-icon matListItemIcon>queue_music</mat-icon>
                                        } @if (element.talkerType=='service') {
                                        <mat-icon matListItemIcon>settings_suggest</mat-icon>
                                        } @if (element.talkerType=='function') {
                                        <mat-icon matListItemIcon>memory</mat-icon>
                                        } @if (element.talkerType=='external') {
                                        <mat-icon matListItemIcon>call</mat-icon>
                                        } @if (element.talkerType=='device') {
                                        <mat-icon matListItemIcon>fax</mat-icon>
                                        } @if (!element.talkerType || element.talkerType=='none') {
                                        <mat-icon matListItemIcon>call</mat-icon>
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        {{ element.talkerName }}
                                        @if (element.talkerName!=element.talkerAddress) {
                                        <sup>&nbsp;({{ element.talkerAddress }})</sup>
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <sup>{{ 'CdrStates.' + element.talkerState | translate }}</sup>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="error">
                        <th mat-header-cell *matHeaderCellDef class="small">
                            <span mat-sort-header>{{ 'Cdrs.Error' | translate }}</span>
                            <mat-form-field class="form-field" appearance="outline">
                                <input matInput (keyup)="applyFilters('error', $event.target)" autocomplete="off" />
                                <button
                                    mat-icon-button
                                    matSuffix
                                    class="header-button"
                                    matTooltip="{{ 'Cdrs.ResetFilterColumn' | translate }}"
                                    (click)="resetColumnFilter('error')"
                                    type="button">
                                    <mat-icon>undo</mat-icon>
                                </button>
                            </mat-form-field>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            @if (element.talkDuration>0) {
                            <mat-icon matListItemIcon [ngStyle]="{ color: 'green' }">check_circle</mat-icon>
                            } @if (element.talkDuration<=0) {
                            <mat-icon matListItemIcon [ngStyle]="{ color: 'orange' }">error</mat-icon>
                            }
                            {{ element.errorDescription }}&nbsp;
                            <sup>({{ element.errorCode }})</sup>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="rule">
                        <th mat-header-cell *matHeaderCellDef class="small">
                            <span mat-sort-header>{{ 'Cdrs.Rule' | translate }}</span>
                            <mat-form-field class="form-field" appearance="outline">
                                <input matInput (keyup)="applyFilters('rule', $event.target)" autocomplete="off" />
                                <button
                                    mat-icon-button
                                    matSuffix
                                    class="header-button"
                                    matTooltip="{{ 'Cdrs.ResetFilterColumn' | translate }}"
                                    (click)="resetColumnFilter('rule')"
                                    type="button">
                                    <mat-icon>undo</mat-icon>
                                </button>
                            </mat-form-field>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.RuleName }}</td>
                    </ng-container>

                    <ng-container matColumnDef="restriction">
                        <th mat-header-cell *matHeaderCellDef class="small">
                            <span mat-sort-header>{{ 'Cdrs.Restriction' | translate }}</span>
                            <mat-form-field class="form-field" appearance="outline">
                                <input matInput (keyup)="applyFilters('restriction', $event.target)" autocomplete="off" />
                                <button
                                    mat-icon-button
                                    matSuffix
                                    class="header-button"
                                    matTooltip="{{ 'Cdrs.ResetFilterColumn' | translate }}"
                                    (click)="resetColumnFilter('restriction')"
                                    type="button">
                                    <mat-icon>undo</mat-icon>
                                </button>
                            </mat-form-field>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.RestrictionName }}</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>

                <mat-paginator [pageSizeOptions]="[25, 50, 100]" class="default-paginator"></mat-paginator>
            </div>
        </form>
    </div>
</div>
